var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M12.8,89.6v332.8h486.4V89.6H12.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M486.4,76.8H25.6C11.46,76.8,0,88.26,0,102.4v307.2c0,14.14,11.46,25.6,25.6,25.6h460.8 c14.14,0,25.6-11.46,25.6-25.6V102.4C512,88.26,500.54,76.8,486.4,76.8z M463.326,102.4L256,240.623L48.674,102.4H463.326z M486.4,409.6H25.6V117.777L248.9,266.65c2.15,1.425,4.625,2.15,7.1,2.15c2.475,0,4.949-0.725,7.1-2.15l223.3-148.873V409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M197.7,270.95L44.1,373.35c-5.888,3.925-7.475,11.878-3.55,17.749c2.466,3.703,6.528,5.7,10.667,5.7 c2.441,0,4.898-0.7,7.091-2.15l153.6-102.4c5.888-3.925,7.475-11.878,3.55-17.749C211.541,268.604,203.597,267.025,197.7,270.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M300.1,292.25l153.6,102.4c2.185,1.451,4.651,2.15,7.091,2.15c4.139,0,8.201-1.997,10.667-5.7 c3.925-5.871,2.338-13.824-3.55-17.749l-153.6-102.4c-5.914-3.925-13.85-2.347-17.749,3.55 C292.625,280.371,294.212,288.324,300.1,292.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailDark);
export default __webpack_public_path__ + "static/media/email_dark.9d357962abb7dce843fea5bae8c69bae.svg";
export { ForwardRef as ReactComponent };